import { useEffect, useState } from 'react';

// Date-dependent markup must be identical in the prerendered HTML and the first
// client render, or React 18 hydration fails. The static HTML is rendered on
// the build day, so start from that date and switch to the visitor's clock
// after mount. (`__BUILD_DATE__` is defined in vite.config.js.)
export const BUILD_DATE = new Date(typeof __BUILD_DATE__ === 'string' ? __BUILD_DATE__ : Date.now());

export function useClientDate() {
  const [date, setDate] = useState(BUILD_DATE);
  useEffect(() => { setDate(new Date()); }, []);
  return date;
}
